// export const BASEURL = "https://api.dev.kwikmemories.com";
export const BASEURL = "https://api.kwikmedia.in";
export const FEEDBACK_SHEET_URL = process.env.REACT_APP_FEEDBACK_SHEET_URL;

// Dev API creates Cashfree sandbox sessions. Production SDK + sandbox session
// → payment_session_id_invalid. Infer from BASEURL when env not set / wrong.
const isDevApi = /api\.dev\.|\/\/dev\./i.test(BASEURL);
export const CASHFREE_MODE = isDevApi
  ? "sandbox"
  : process.env.REACT_APP_CASHFREE_MODE === "sandbox"
    ? "sandbox"
    : "production";
